import { downloadFromUrl } from 'utils/files'
import { MouseEvent } from 'react'
import { TFunction } from 'i18next'

const T_FILE_UPLOADER_ROOT = 'fileUploader'
const T_WIZARD_ROOT = 'wizard.documents.file_uploaders'

export const getFileTypesString = (fileTypes: Record<string, string[]>): string =>
  Object.entries(fileTypes)
    .map(([, value], index, array) => {
      if (array.length === 1) {
        return `${value[0]}`.toUpperCase()
      } else if (index === array.length - 2) {
        return `${value[0]} y`.toUpperCase()
      } else {
        return `${value[0]}`.toUpperCase()
      }
    })
    .join(' ')

export const getButtonProps = ({
  defaultFileURL,
  disabled,
  hasDefaultFile,
  isFailUpload,
  isFileAccepted,
  isFileRejected,
  onClick,
  onClickDelete,
  t
}: {
  defaultFileURL: string
  disabled: boolean
  hasDefaultFile: boolean
  isFailUpload?: boolean
  isFileAccepted: boolean
  isFileRejected: boolean
  onClick: () => void
  onClickDelete: (e: MouseEvent<HTMLElement>) => void
  t: TFunction
}): { handleClick: (e: MouseEvent<HTMLElement>) => void; label: string } => {
  const uploadText = t(`${T_FILE_UPLOADER_ROOT}.uploadButton`)
  const disabledButton = t(`${T_FILE_UPLOADER_ROOT}.disabledButton`)
  const showFileButton = t(`${T_FILE_UPLOADER_ROOT}.showFileButton`)
  const deleteButton = t('command.delete')
  const retryButton = t('command.retry')
  const defaultValue = { handleClick: onClick, label: '' }
  if (hasDefaultFile) return { handleClick: () => downloadFromUrl(defaultFileURL), label: showFileButton }
  if (isFailUpload) return { ...defaultValue, label: retryButton }
  if (isFileAccepted) return { handleClick: onClickDelete, label: deleteButton }
  if (isFileRejected) return { ...defaultValue, label: retryButton }
  if (disabled) return { ...defaultValue, label: disabledButton }
  return { ...defaultValue, label: uploadText }
}

export const getDescMessage = ({
  defaultFileName,
  defaultFileURL,
  errorMessage,
  fileDesc,
  fileName,
  fileTypes,
  isFileAccepted,
  isFileRejected,
  t
}: {
  defaultFileName?: string
  defaultFileURL?: string
  errorMessage: string
  fileDesc?: string
  fileName: string
  fileTypes: Record<string, string[]>
  isFileAccepted: boolean
  isFileRejected: boolean
  t: TFunction
}): string => {
  if (errorMessage || isFileRejected) return errorMessage
  if (defaultFileURL && defaultFileName) return defaultFileName
  if (isFileAccepted) return fileName
  if (fileDesc) return fileDesc
  if (!fileTypes) return ''
  return t(`${T_WIZARD_ROOT}.formats`, { formats: getFileTypesString(fileTypes) }).toString()
}
